<template>
  <div class="form-group">
    <label v-if="label" :for="name">{{ label }}</label><span class="text-danger mx-1" v-if="required">*</span>
    <input :autocomplete="autocomplete" class="form-control" :type="type" :id="name" :name="name" :placeholder="placeholder"
           v-model="vModel" :disabled="!!disabled" @keyup="onKeyUp" :readonly="readonly"
           :maxlength="maxLength"
           :minlength="minLength"
           @input="handleInput" @blur="validateValue"/>
    <small class="form-text text-danger" v-if="validationError || getErrorMessage">
      {{ validationError || getErrorMessage }}
    </small>
  </div>
</template>

<script>
import Lang from '@lang';

export default {
  props: {
    label: {
      type: String
    },
    placeholderLabel: {
      type: String,
      default: ''
    },
    isPhoneNumber: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'text'
    },

    name: {
      type: String,
      required: true
    },

    model: {
      type: [Object, Array],
      required: true
    },

    errors: {
      type: [Object, Array],
      // required: true
    },
    error_name: {
      type: String,

    },

    disabled: {
      type: [Boolean, Number]
    },

    required: {
      type: Boolean
    },

    readonly: {
      type: String
    },
    minLength: {
      type: Number,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    autocomplete: {
      type: String,
      default: 'off'
    }
  },

  computed: {
    placeholder() {
      return this.label && !this.placeholderLabel ? `${Lang.get('messages.enter')} ${this.label}` : `${this.placeholderLabel}`;
    },

    getErrorMessage() {
      if (!this.errors) return null;
      const errorKey = this.error_name || this.name;
      const errorArray = _.get(this.errors, errorKey);
      return errorArray && errorArray.length > 0 ? errorArray[0] : null;
    },

    vModel: {
      get: function () {
        return _.get(this.model, this.name);
      },
      // setter
      set: function (newValue) {
        // _.set(this.model, this.name, newValue);
        // console.log(this.name);
        if (this.name.includes('.')) {
          /* let base = this.name.substring(0, this.name.lastIndexOf('.'));
          // base = 'content';
          let name = this.name.substring(this.name.lastIndexOf('.') + 1, this.name.length);
          // console.log(this.model[base]);
          this.$set(this.model[`${base}`], name, newValue); */
          _.set(this.model, this.name, newValue);
        } else {
          this.$set(this.model, this.name, newValue);
        }

      }
    }
  },
  data() {
    return {
      validationError: '',
      hadInvalidInput: false,
      patterns: {
        english: {
          regex: /^[A-Za-z\s]*$/,
          message: Lang.get('messages.english_only')
        },
        arabic: {
          regex: /^[\u0600-\u06FF\s]*$/,
          message: Lang.get('messages.arabic_only')
        },
        numbers: {
          regex: /^\d*$/,
          message: Lang.get('messages.numbers_only')
        },
        mobile: {
          regex: /^05\d{8}$/,
          message: Lang.get('messages.mobile_format')
        },
        email: {
          regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: Lang.get('messages.email_format')
        },
        custom: null // Will be set dynamically based on rules
      }
    }
  },

  methods: {
    onKeyUp(value) {
      this.$emit('keyup', value);
      // this.$forceUpdate();
    },
    onBlur(value) {
      this.$emit('blur', value);
      // this.$forceUpdate();
    },

    handleInput(event) {
      let value = event.target.value;
      let originalValue = value;
      this.hadInvalidInput = false; // reset
      if (this.rules?.pattern) {
        const patternRule = this.rules.pattern;

        // Check if we should remove invalid characters
        if (patternRule.removeInvalid) {
          let validPattern;

          if (patternRule.base === 'english') {
            validPattern = /[A-Za-z\s]/;
          } else if (patternRule.base === 'arabic') {
            validPattern = /[\u0600-\u06FF\s]/;
          } else if (patternRule.base === 'numbers') {
            validPattern = /\d/;
          } else if (patternRule.base === 'custom') {
            // Special handling for email pattern
            if (patternRule.regex.toString().includes('@')) {
              validPattern = /[a-zA-Z0-9.@_+-]/;
            } else {
              // For other custom patterns
              const regexStr = patternRule.regex.toString();
              const pattern = regexStr.slice(1, regexStr.lastIndexOf('/')).replace(/^\^|\$$/g, '');
              try {
                validPattern = new RegExp(`[${pattern}]`);
              } catch (e) {
                console.warn('Could not create character validation pattern:', e);
                validPattern = null;
              }
            }
          }

          if (validPattern) {
            // Check if any invalid chars are present
            let filtered = value.split('').filter(char => validPattern.test(char)).join('');
            if (filtered !== value) {
              this.hadInvalidInput = true; // <--- set flag if chars were removed
            }
            value = filtered;
          }

          // Handle startsWith if specified
          // if (patternRule.startsWith) {
          //     const startValue = String(patternRule.startsWith);
          //     if (!value.startsWith(startValue)) {
          //         // If value already starts with a different number, replace it
          //         if (/^\d/.test(value)) {
          //             value = startValue + value.slice(1);
          //         } else {
          //             value = startValue + value;
          //         }
          //         event.target.value = value;
          //     }
          // }
        }
      }

      // Handle length validation
      if (this.rules?.length?.max && value.length > this.rules.length.max) {
        value = value.slice(0, this.rules.length.max);
        event.target.value = value;
      }

      this.updateValue(value);
      const isValid = this.validateValue(value, originalValue);
      // Emit validation state change
      this.$emit('validation-change', isValid);
    },

    validateValue(value, originalValue = null) {
      const errors = [];

      if (typeof value === 'object') {
        value = value.target.value;
      }

      // Required validation
      if (this.required && !value) {
        if (this.hadInvalidInput && originalValue && originalValue.length > 0) {
          errors.push(this.rules.pattern?.message || Lang.get('messages.invalid_format'));
        } else {
          errors.push(Lang.get('messages.field_required'));
        }
        this.validationError = errors.join(', ');
        this.$emit('validation-change', false);
        return false;
      }

      if (value && this.rules) {
        // Pattern validation
        if (this.rules.pattern) {
          const pattern = this.rules.pattern.base === 'custom'
              ? this.rules.pattern.regex
              : this.patterns[this.rules.pattern.base]?.regex;

          if (pattern && !pattern.test(value)) {
            errors.push(this.rules.pattern.message);
          }

          // StartsWith validation
          if (this.rules.pattern.startsWith &&
              !value.startsWith(this.rules.pattern.startsWith)) {
            errors.push(this.rules.startWith?.message ||
                Lang.get('messages.should_start_with') + " " + this.rules.pattern.startsWith);
          }
        }

        // Length validation
        if (this.rules.length) {
          if (this.rules.length.max && value.length > this.rules.length.max) {
            errors.push(this.rules.length.maxMessage ||
                `${Lang.get('messages.max_length')} ${this.rules.length.max}`);
          }
          if (this.rules.length.min && value.length < this.rules.length.min) {
            errors.push(this.rules.length.minMessage ||
                `${Lang.get('messages.min_length')} ${this.rules.length.min}`);
          }
        }
      }

      if (this.isPhoneNumber && value) {
        if (value.startsWith('0')) {
          if (!value.startsWith('05')) {
            errors.push(Lang.get('messages.must_start_with_05') || 'Phone number must start with 05');
          } else if (value.length !== 10) {
            errors.push(Lang.get('messages.must_be_10_digits_with_zero') || 'Must be 10 digits when starting with 0');
          }
        } else {
          if (value.length !== 9) {
            errors.push(Lang.get('messages.must_be_9_digits_without_zero') || 'Must be 9 digits when not starting with 0');
          }
        }
      }


      this.validationError = errors[0] || '';
      const isValid = errors.length === 0;
      this.$emit('validation-change', isValid);
      return isValid;
    },


    updateValue(value) {
      if (this.name.includes('.')) {
        _.set(this.model, this.name, value);
      } else {
        this.$set(this.model, this.name, value);
      }
      this.$emit('input', value);
      this.$emit('change', value);
      this.validateValue(value);
    }
  },
  watch: {
    'rules.pattern': {
      handler(newPattern, oldPattern) {
        if (newPattern?.startsWith !== oldPattern?.startsWith) {
          if (this.vModel && newPattern?.startsWith) {
            const currentValue = this.vModel;
            const startValue = String(newPattern.startsWith);

            // If current value exists and starts with a different number
            if (currentValue && !currentValue.startsWith(startValue) && /^\d/.test(currentValue)) {
              // Replace the first digit with the new startsWith value
              const newValue = startValue + currentValue.slice(1);
              this.updateValue(newValue);
            }
          }
        }
      },
      deep: true
    },
    errors: {
      handler(newErrors) {
        if (newErrors) {
          const errorKey = this.error_name || this.name;
          const errorArray = _.get(newErrors, errorKey);
          if (errorArray && errorArray.length > 0) {
            this.validationError = errorArray[0];
            this.$emit('validation-change', false);
          } else {
            this.validationError = '';
            this.$emit('validation-change', true);
          }
        } else {
          this.validationError = '';
          this.$emit('validation-change', true);
        }
      },
      deep: true,
      immediate: true
    }
  },

};
</script>

<style></style>